import { VueConstructor } from "vue";
import QuickJump from "~/components/experimental/quick-jump.vue";
import Storager from "./storager";

const storager = new Storager('formability:features')

let service = class QuickJumpService {

  static install(Vue: VueConstructor, options) {
    Vue.component("quick-jump", QuickJump);
    const quickJumpInstance = new QuickJump()

    window.addEventListener("DOMContentLoaded", () => {
      const features = storager.get

      if (features?.quick_jump?.development || features?.quick_jump?.production) {
        quickJumpInstance.$mount();
        document.getElementsByTagName('body')[0].appendChild(quickJumpInstance.$el)

        $(document).on('keydown', (event) => {
          if (event.ctrlKey && [71].includes(event.which)) {
            event.preventDefault();

            // @ts-ignore
            quickJumpInstance.toggleModal()
          }
        })
      }
    })
  }
}

export default service
